// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3zL1D","filesListContainer":"PosDisputesFiles_filesListContainer__3NC3s","filesButton":"PosDisputesFiles_filesButton__3WuR3"};